module.exports = __webpack_public_path__ + "img/fb3.73b3bd76.png";